import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CALCULATORS } from "../content/calculators";
import { CalculatorPage } from "../components/calc/CalculatorPage";
import { api } from "../lib/api";
import NotFound from "./NotFound";

export default function CalculatorRoute() {
  const { slug } = useParams();
  const calc = CALCULATORS[slug];
  const [pageSeo, setPageSeo] = useState(null);
  const [feeConfig, setFeeConfig] = useState(null);

  useEffect(() => {
    if (!calc) return;
    api.get(`/pages/${slug}`).then(({ data }) => setPageSeo(data)).catch(() => {});
    if (calc.feeMarketplace) {
      api.get("/fees").then(({ data }) => {
        setFeeConfig(data.find((f) => f.marketplace === calc.feeMarketplace) || null);
      }).catch(() => {});
    }
  }, [slug, calc]);

  if (!calc) return <NotFound />;
  return <CalculatorPage calc={calc} pageSeo={pageSeo} feeConfig={feeConfig} />;
}
